"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsReceived = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var IsReceived = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsReceived, _super);
    function IsReceived() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取优惠券';
        _this.code = '300205';
        _this.desc = '获取优惠券';
        _this.requestParams = new coupon_1.IsReceivedRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsReceived;
}(service_1.BaseService));
exports.IsReceived = IsReceived;
//# sourceMappingURL=isreceived.js.map